<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 15:09:19
 * @LastEditTime: 2019-10-09 17:07:42
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div class="container">
       <div class="pageTitle">入库管理</div>
        <el-button type="primary" @click="add()" style="width:120px;height: 40px;margin: 20px" class="btnColor">添加入库单</el-button>
        <el-form ref="form" :model="form" label-width="100px" :inline="true" class="mt20">
            <el-form-item label="入库时间:" style="text-align: center">
                <el-col :span="11">
                    <el-date-picker type="date" placeholder="开始时间" v-model="form.start_time"
                                    style="width: 100%;"></el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                    <el-date-picker type="date" placeholder="结束时间" v-model="form.end_time"
                                    style="width: 100%;"></el-date-picker>
                </el-col>
              
            </el-form-item>
          
            <el-form-item label="产品编号:">
                <el-input v-model="form.product_sn" clearable></el-input>
            </el-form-item>
            <el-form-item label="入库仓库:">
                <el-select v-model="form.warehouse_sn">
                    <el-option key="" label="全部" value=""></el-option>
                    <el-option v-for=" i in stockArray" :key="i.warehouse_sn" :label="i.warehouse_name"
                               :value="i.warehouse_sn"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="入库单号:">
                <el-input v-model="form.stock_in_sn" clearable></el-input>
            </el-form-item>
            <el-form-item label="生产批次号:">
                <el-input v-model="form.production_batch" clearable></el-input>
            </el-form-item>
            <el-form-item label="产品名称:">
                <el-input v-model="form.product_name" clearable></el-input>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="onSearch()">搜索</el-button>
                <el-button @click="exportData()">导出</el-button>
            </el-form-item>
        </el-form>
        <!--表格-->
        <el-table
                ref="multipleTable"
                :data="tableData"
                v-loading="loading"
                border
                stripe
                height="350"
               >
            <el-table-column
                    type="selection"

                    fixed>
            </el-table-column>
            <el-table-column
                    label="序号"
                    width="80"
                    prop="id"
            >
            </el-table-column>
            <el-table-column
                    prop="stock_in_sn"
                    label="入库单号"
                   width="150"
                    fixed>
            </el-table-column>
            <el-table-column
                    prop="production_batch"
                    label="生产批次号"
                   width="150"
                    >
            </el-table-column>
            <el-table-column
                    prop="stock_in_num"
                    label="入库数量"
                     width="50"
                    >
            </el-table-column>
            <el-table-column
                    prop="real_stock_in_num"
                    label="已入库数量"
                    width="50"
                    >
                <template slot-scope="scope">
                    <span style="color:red;cursor: pointer" @click="detail(scope.row)">{{scope.row.real_stock_in_num}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="product_name"
                    label="产品名称"
                     width="150"
                   >
            </el-table-column>
            <el-table-column
                    prop="product_sn"
                    label="产品编号"
                     width="150"
                    >
            </el-table-column>
            <el-table-column
                    prop="product_specs"
                    label="规格"
                     width="80"
                    >
            </el-table-column>
            <el-table-column
                    prop="brand_name"
                    label="品牌"
                     width="100"
                   >
            </el-table-column>
            <el-table-column
                    prop="manufacturer"
                    label="生产商家"
                     width="150"
                    >
            </el-table-column>
            <el-table-column
                    prop='product_bar_code'
                    label="条码"
                     width="150"
                   >
            </el-table-column>
            <el-table-column
                    prop='approval_number'
                    label="批准条文"
                     width="150"
                   >
            </el-table-column>
            <el-table-column
                    prop="production_date"
                    label="生产日期"
                  
                   >
            </el-table-column>
            <el-table-column
                    prop="expiring_date"
                    label="有效期至"
                 
                    >
            </el-table-column>
             <el-table-column
                    prop="warehouse_name"
                    label="入库仓库"
                 
                    >
            </el-table-column>
            <el-table-column
                    prop="created_at"
                    label="建单时间"
                    width="120"
                  >
            </el-table-column>
            <el-table-column
                    fixed="right"
                    prop=""
                    label="操作"
                    width="180"
                    >
                <template slot-scope="scope">
           
                    <el-button type="text" size="small" @click="print(scope.row)">打印</el-button>
                    <el-button type="text" size="small" @click="editInstock(scope.row)">编辑</el-button>
                    <el-button type="text" size="small" @click="deliver(scope.row)" v-if='scope.row.real_stock_in_num==scope.row.stock_in_num'>一键发货</el-button>
                    <el-button type="text" size="small" @click="del(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--分页-->
        <el-pagination
                style="margin: 20px 0"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNo"
                :page-sizes="[20, 50, 100, 200]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalSize">
        </el-pagination>
        <!--发货-->
        <deliverDialog
        v-if="deliverDialog"
        v-on:handleClose = 'deliverDialog = false'
        :delData="delData">
        </deliverDialog>
        <!--物流码明细-->
        <instockDetailDialog
                v-if="instockDetailDialogVisable"
                v-bind:detailData="stock_in_sn"
                v-on:handleClose = 'instockDetailDialogVisable = false'>
        </instockDetailDialog>


    </div>

</template>

<script>
    import deliverDialog from './deliverDialog';
    import instockDetailDialog from './instockDetail'


    export default {
        name: "instock-manage",
        data() {
            return {
                deliverDialog:false,
                codeDialog:false,
                form: {
                    product_sn: '',
                    stock_in_sn: '',
                    production_batch: '',
                    product_name: '',
                    start_time: '',
                    end_time: '',
                    warehouse_sn:""
                },
                tableData: [
                ],
                instockDetailDialogVisable:false,
                stock_in_sn:'',//查看明细传递的入库单号
                delData:{},//发货
               //分页
                pageNo: 1,
                pageSize: 20,
                totalSize: 0,
                loading:false,
                stockArray:[]
            }
        },
        methods:
            {
                //获取仓库
                getStock() {
                    this.$get('logistics', '/warehouses.all', {
                        lang: ''
                    }).then(res => {
                        this.stockArray = res.data;
                    }).catch(function (error) {
                        console.log(error);
                    });
                },
                getLastMonth() {
                    var now = new Date();
                    var year = now.getFullYear();//getYear()+1900=getFullYear()
                    var month = now.getMonth() + 1;//0-11表示1-12月
                    var day = now.getDate();
                    var dateObj = {};
                    if (parseInt(month) < 10) {
                        month = "0" + month;
                    }
                    if (parseInt(day) < 10) {
                        day = "0" + day;
                    }

                    dateObj.now = year + '-' + month + '-' + day;

                    if (parseInt(month) == 1) {//如果是1月份，则取上一年的12月份
                        dateObj.last = (parseInt(year) - 1) + '-12-' + day;
                        return dateObj;
                    }

                    var preSize = new Date(year, parseInt(month) - 1, 0).getDate();//上月总天数
                    if (preSize < parseInt(day)) {//上月总天数<本月日期，比如3月的30日，在2月中没有30
                        dateObj.last = year + '-' + month + '-01';
                        return dateObj;
                    }

                    if (parseInt(month) <= 10) {
                        dateObj.last = year + '-0' + (parseInt(month) - 1) + '-' + day;
                        return dateObj;
                    } else {
                        dateObj.last = year + '-' + (parseInt(month) - 1) + '-' + day;
                        return dateObj;
                    }

                },
                //请求列表数据
                onSearch(){
                    let beginstr = '', endstr = '';
                    if(this.form.start_time){
                        this.form.start_time = this.moment(this.form.start_time).format("YYYY-MM-DD")
                    }
                    if(this.form.end_time){
                        this.form.end_time = this.moment(this.form.end_time).format("YYYY-MM-DD");
                    }
                    this.loading = true;
                    this.$get('logistics','/inwarehouses', {
                        lang:'',
                        ...this.form,
                        
                        per_page:this.pageSize,
                        page:this.pageNo
                    }).then(res => {
                        this.loading = false;
                        //console.log(res);
                        this.tableData = res.data;
                        this.totalSize = res.meta.total;
                    }).catch(function (error) {
                        this.loading = false;
                        console.log(error);
                    });
                },
                //导出
                exportData(){
                    let beginstr = '', endstr = '';
                    if(this.form.start_time){
                        beginstr = this.moment(this.form.start_time).format("YYYY-MM-DD")
                    }
                    if(this.form.end_time){
                        endstr = this.moment(this.form.end_time).format("YYYY-MM-DD");
                    }
                    let url = '',access_tokens = localStorage.getItem('access_tokens');
                    window.open( this.$Base_Export
                    +'/inwarehouses.export?start_time=' + beginstr +'&end_time=' + endstr + '&product_sn=' +
                    this.form.product_sn +'&stock_in_sn=' + this.form.stock_in_sn + '&production_batch=' + this.form.production_batch+
                    '&product_name=' +this.form.product_name + '&lang=' + ''+'&signature='+ this.$md5(access_tokens)+'&is_export=1'
                    )
                },
                //物流吗明细
                detail(row){
                    this.stock_in_sn = row.stock_in_sn;
                    this.instockDetailDialogVisable = true;
                },
                /*修改入库*/
                editInstock(row){
                    this.$router.push({
                        name:'editInstock',
                        query:{
                            stock_in_sn:row.stock_in_sn
                        }
                    });
                },
                //打印入库单
                print(row){
                    this.$router.push({
                        name:'printInstock',
                        query:{
                            stock_in_sn:row.stock_in_sn,
                        }
                    });
                },
                /*分页*/
                handleSizeChange(val) {
                    this.pageSize = val;
                    this.pageNo = 1;
                    this.onSearch();
                },
                handleCurrentChange(val) {
                    this.pageNo = val;
                    this.onSearch();
                },
                //添加入库
                add() {
                    this.$router.push({
                        name: 'addInstock'
                    });

                },
                handleSelectionChange(val) {
                    this.multipleSelection = val;
                },
                //发货
                deliver(row){
                    this.delData = row;
                this.deliverDialog = true;
                },
                //删除
                del(row) {
                    this.$confirm('是否删除?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let str = row.stock_in_sn,
                            url = '/inwarehouses/' + str;
                        this.$delete('logistics',url, {
                        }).then(res => {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.onSearch();
                        }).catch(error =>{
                            this.$message({
                                type: 'error',
                                message: error.message
                            });

                        });
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });
                    });

                }

            },
        created() {
            this.getStock();
            this.form.start_time = this.getLastMonth().last;
            this.form.end_time = this.getLastMonth().now;
            this.onSearch();
        },
        components:{
            deliverDialog,instockDetailDialog
        }
    }
</script>
<style lang="scss" scoped>


</style>